import { injectable } from 'inversify';

import { HttpService } from '@vk-hr-tek/core/http';

import { GenerateDocumentDto } from '../../dto';

@injectable()
export class SettingsTemplatesService {
  constructor(private http: HttpService) {}

  async generateDocumentPreview(generateDocumentDto: GenerateDocumentDto) {
    const { templateId, attributes, fileId } = generateDocumentDto;

    const result = await this.http.generateFile(
      `/template/${templateId}/preview`,
      {
        ...(fileId && { file_id: fileId }),
        items: attributes,
      },
      { withSide: true, withIndicies: true, isJson: true },
    );

    return result;
  }
}
